// ============================================
// ALPHAMETA CONFIGURATION
// Change USE_MAINNET to switch networks
// ============================================

// Set to true for BSC Mainnet, false for BSC Testnet
export const USE_MAINNET = true;

// BSC Mainnet Configuration
const MAINNET_CONFIG = {
  chainId: 56,
  chainIdHex: '0x38',
  chainName: 'BNB Smart Chain',
  rpcUrls: ['https://bsc-dataseed1.binance.org/', 'https://bsc-dataseed2.binance.org/'],
  blockExplorerUrls: ['https://bscscan.com/'],
  nativeCurrency: {
    name: 'BNB',
    symbol: 'BNB',
    decimals: 18
  },
  contractAddress: '0x5c7fbBe6C6E107cB9d9e8BD2BF63dc2b93D34242',
  tokenAddress: '0x55d398326f99059fF775485246999027B3197955', // BSC USDT
};

// BSC Testnet Configuration
const TESTNET_CONFIG = {
  chainId: 97,
  chainIdHex: '0x61',
  chainName: 'BNB Smart Chain',
  rpcUrls: ['https://data-seed-prebsc-1-s1.binance.org:8545/'],
  blockExplorerUrls: ['https://testnet.bscscan.com/'],
  nativeCurrency: {
    name: 'BNB',
    symbol: 'BNB',
    decimals: 18
  },
  contractAddress: '0xa8B86C24F28F5C9915083c7BD5EBeC66de09d078',
  tokenAddress: '0x2620D043772DdE2a4B5cfBB807Aa3ebd678DD1DC', // Testnet USDT
};

export const NETWORK_CONFIG = USE_MAINNET ? MAINNET_CONFIG : TESTNET_CONFIG;

export const TOKEN_CONFIG = {
  symbol: 'USDT',
  decimals: 18,
  name: 'Tether USD'
};

export const APP_CONFIG = {
  appName: 'AlphaMeta',
  appTagline: 'AI-Powered DeFi Trading',
  defaultReferrerId: 5000,
  minInvestment: 10,
  investmentMultiple: 10,
  profitRange: { min: 0.5, max: 1.0 },
  levelCount: 15,
  clubCount: 8,
  profitCeiling: 200,
  totalCeiling: 300,
  telegramApiUrl: 'https://alphameta.tech/api/telegram.php',  // Update this to your actual URL in production
  telegramBotUsername: '@AlphaMeta_Trading_Bot',
  telegramBotLink: 'https://t.me/AlphaMeta_Trading_Bot'
};

export const AI_BOT_NAMES = [
  'AlphaBot-X1', 'QuantumTrader-7', 'NeuralNet-Pro', 'DeepMind-A2',
  'CyberTrade-V3', 'OmegaBot-Elite', 'TitanAI-9000', 'VortexTrader-Z',
  'PhoenixAI-Ultra', 'NexusBot-Prime', 'ApexTrader-X7', 'SentinelAI-V2',
  'MatrixBot-Omega', 'ZenithTrader-Pro', 'HyperAI-Quantum', 'NovaBot-Supreme',
  'PulsarAI-Elite', 'SpectraTrader-X', 'InfinityBot-Z9', 'CosmosAI-Prime'
];

export const CLUB_NAMES = [
  'Junior', 'Senior', 'Silver', 'Gold',
  'Royal', 'Diamond', 'Crown', 'Meta'
];

export const ACTIVITY_TYPES = {
  1: { label: 'Investment', icon: '💎', color: '#00f7ff' },
  2: { label: 'Profit Earned', icon: '📈', color: '#00ff88' },
  3: { label: 'Level Income', icon: '🎯', color: '#a855f7' },
  4: { label: 'Withdrawal', icon: '💸', color: '#fbbf24' },
  5: { label: 'Direct Referral', icon: '👥', color: '#3b82f6' },
  6: { label: 'Referral Bonus', icon: '🎁', color: '#ec4899' },
  7: { label: 'Club Reward', icon: '🏆', color: '#f97316' }
};
